import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import CustManCards from './CustManCards';
import { useSelector } from 'react-redux';
import warningIcon from '../common/asset1/warning-symbol.svg';
import successtick from '../common/asset1/tick-mark.png';

const apiUrl = process.env.REACT_APP_API_URL;

const CloseStaff = () => {
    const navigate = useNavigate();
    const reduxSchemeID = useSelector(state => state.auth.reduxSchemeID);
    const additionalCustomerId = useSelector((state) => state.auth.additionalCustomerId);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false); 
    const [formData, setFormData] = useState({
        customerEnrolledSchemeId: reduxSchemeID || 0,
        customerId: additionalCustomerId || 0,
        schemeId: 0,
        staffName: '',
        closureReason: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const onClickGoBack = () => {
        navigate('/admin/home/viewing-user-profile');
    };

    const handleSubmit = async () => {
        const newErrors = {};
        if (!formData.staffName) {
            newErrors.staffName = 'Staff name is required.';
        }
        if (!formData.closureReason) {
            newErrors.closureReason = 'Closure reason is required.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            const response = await fetch(`${apiUrl}/enrolledscheme/closescheme`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                const result = await response.json();
                setIsSubmitted(true); 
                console.log(result);
            } else {
                console.error('Failed to close the scheme');
                alert('Failed to close the scheme. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while closing the scheme.');
        }
    };

    return (
        <div className="whole-mysave-cont">
            <CustManCards />
            <div className="close-use-out">
                <div className="close-form-go-back">
                    <button className="get-back-out" onClick={onClickGoBack}>
                        <Icon icon="iconamoon:arrow-left-2-bold" className="go-back-symbol" />
                        Go Back
                    </button>
                </div>

                {!isSubmitted ? (
                    <div className="close-form-staff">
                        <label>
                            Handling for Closure
                            <input
                                type="text"
                                name="staffName"
                                placeholder="Handling for Closure"
                                value={formData.staffName}
                                onChange={handleInputChange}
                            />
                            {errors.staffName && (
                                <div className="error-reg-icon-out">
                                    <img src={warningIcon} alt="Warning-Icon" className="warning-icon" />
                                    <span className="error-register-now">{errors.staffName}</span>
                                </div>
                            )}
                        </label>

                        <label>
                            Reason for Closure
                            <input
                                type="text"
                                name="closureReason"
                                placeholder="Reason for Closure"
                                value={formData.closureReason}
                                onChange={handleInputChange}
                            />
                            {errors.closureReason && (
                                <div className="error-reg-icon-out">
                                    <img src={warningIcon} alt="Warning-Icon" className="warning-icon" />
                                    <span className="error-register-now">{errors.closureReason}</span>
                                </div>
                            )}
                        </label>

                        <button className="close-proceed" onClick={handleSubmit}>
                            Close Scheme
                        </button>
                    </div>
                ) : (
                    <div className="success-message-teeny-cont">
                        <div className="success-icon-wrapper">
                            <img src={successtick} alt="success-mark" className="success-tick-mark" />
                        </div>
                        <p>Scheme closed successfully</p>
                        <div className="created-name-id-out">
                            <div className="created-name-id">
                                <label>Name: </label>
                                <span>{formData.staffName}</span>
                            </div>
                            <div>
                                <label>Customer ID: </label>
                                <span>{formData.customerId}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CloseStaff;
